<template>
  <div id="app" :class="{ filter: showFilter }">
    <a-config-provider :locale="zhCN" :transformCellText="({ text }) => text ?? '--'">
      <template #renderEmpty>
        <div class="emptySlot">
          <auth-img :src="emptyImg" alt="" />
          <p>暂无数据</p>
        </div>
      </template>
      <router-view />
      <Tccc />
      <MsgReminder />
      <!-- 患者档案 -->
      <PatientFile />
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import Tccc from '@/components/Tccc'
import MsgReminder from '@/components/MsgReminder/index.vue'
import { onMounted, computed } from 'vue'
import { hungUp } from '@/utils/Tccc'
import { useStore } from 'vuex'
import { setMsgListFromStorage } from '@/utils/unReadNum'
import PatientFile from '@/components/PatientFile/index.vue'
export default {
  name: 'App',
  components: {
    PatientFile,
    Tccc,
    MsgReminder
    // InstantOrder
  },
  setup() {
    const store = useStore()
    const emptyImg = require('@/assets/img/empty.png')
    const showFilter = computed(() => store.getters.showFilter)

    onMounted(() => {
      window.onbeforeunload = () => {
        hungUp(false)
      }
      if (store.getters.token) {
        // 刷新处理未读消息
        setMsgListFromStorage()
      }
    })
    return { zhCN, emptyImg, showFilter } // 返回形式根据语法糖再改
  }
}
</script>
<style lang="scss">
#app {
  min-width: 1000px;
  &.filter {
    filter: blur(4px);
  }
}
.ant-drawer-title {
  font-weight: bold !important;
}
.emptySlot {
  text-align: center;
  p {
    margin-top: 17px;
    font-size: 14px;
    color: #999999;
  }
}
.z-fixed {
  display: flex;
  align-items: center;
}

.z-fixed-c {
  display: flex;
  align-items: center;
  justify-content: center;
}
.elip--multiple {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  white-space: normal;
  -webkit-box-orient: vertical;
}
</style>
